import React from 'react';
import { Skeleton } from "primereact/skeleton"

export function SkeletonLoader(props) {
    const { rectangle, card } = props;
    const circleRectangleSkeleton = <div className="d-flex mb-3">
        <Skeleton shape="circle" size="3rem" />
        <div style={{ flex: '1', marginLeft: '1rem' }}>
            <div className="mb-2">
                <Skeleton width="100%" height="2rem" />
            </div>
            <Skeleton width="75%" />
        </div>
    </div>
    const rectangleSkeleton = <Skeleton className="my-3 py-3" />
    const cardSkeleton = <div className='my-2'>
        <div className="p-d-flex p-mb-3">
            <Skeleton shape="circle" size="3rem" className="p-mr-2"></Skeleton>
            <div>
                <Skeleton width="10rem" className="p-mb-2"></Skeleton>
                <Skeleton height=".5rem"></Skeleton>
                <Skeleton width="5rem" height=".5rem" className='mt-2'></Skeleton>
            </div>
        </div>
        <Skeleton width="100%" height="150px" />
    </div>
    let skeletonItem = rectangle ? rectangleSkeleton : circleRectangleSkeleton;
    skeletonItem = card ? cardSkeleton : skeletonItem;
    return (
        <div className="container">
            {[...Array(props.factor)].map(() => skeletonItem)}
        </div>
    );
}